<template>
    <v-card
    :hover="true"
    class="mt-3 mb-6"
    >
        <v-card-title
        class="headline cyan darken-1"
        >
            <v-icon
            class="mr-2 white--text">mdi-ticket-outline
            </v-icon>

            <span class="white--text">{{promo.title}} @ {{promo.locationName}}</span>
        </v-card-title>

        <v-img src="https://images.unsplash.com/photo-1482275548304-a58859dc31b7?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2110&q=80"></v-img>

        <v-card-subtitle>
            {{promo.description}}
        </v-card-subtitle>
        <v-divider></v-divider>
        <v-card-text>
            <v-icon color="red darken-1">mdi-exclamation-thick</v-icon>
            Only available at Greenwood Village Location, pick-up only, must order by 4pm directly with Indulge
        </v-card-text>
        <v-divider></v-divider>
        <v-card-text>
            <v-row class="d-flex">
                <v-col>
                <v-icon>mdi-map-marker</v-icon>
                    <span class="ml-2">123 Road Street Denver, CO</span>
                <br>
                <v-icon>mdi-phone</v-icon>
                    <span class="ml-2">(303)111-2222</span>
                    <br>
                <v-icon>mdi-earth</v-icon>
                    <a href="https://www.google.com" class="ml-2">google.com</a>
                </v-col>
                <v-col>
                    <p class="text-end">
                        <v-icon>mdi-clock-outline</v-icon>
                        Expires in: {{ diffTime }}</p>
                </v-col>
            </v-row>
        </v-card-text>
        <v-card-actions>
            <v-btn
            color="warning"
            class="ma-3"
            :to="{ name: 'PromoDetail', params: { id: promo.id, promo: promo } }"
            >
                Claim Promo
            </v-btn>
        </v-card-actions>

    </v-card>
</template>

<script>
    import * as moment from 'moment'
    export default {
        props: {
            promo:Object
        },
        name: "PromoCard",
        data() {
            return{
                end: this.promo.endTime
            }
        },
        computed: {
            endtime: function() {
                var rawEnd = this.end
                var parsedEnd = rawEnd.replace('UTC', '')
                var momentEnd = moment(parsedEnd, "HH:mm").format("HH:mm")
                return momentEnd
            },
            now: function() {
                return moment(Date()).utc()
                    // .format("HH:mm")
            },
            diffTime: function() {
                var duration = moment.utc(this.endtime, "HH:mm")
                    .diff(moment(Date()).utc())
                var mDuration = moment.duration(duration)
                var hoursLeft = mDuration.hours()
                var minutesLeft = mDuration.minutes()
                var timeLeft = hoursLeft + 'h' + ' ' + minutesLeft + 'm'
                return timeLeft
            }
        }
    }
</script>

<style scoped>

</style>